'use strict';
//***********************************************************************************
//***********************************************************************************
//**** Balconies nomenclature
//***********************************************************************************
//***********************************************************************************

import { cn_nomenclature, export_layers_and_zpsos, find_zone, push_cn_nomenclatures_zones } from '../cn_nomenclature';
import { cn_azimut, cn_dist, cn_mul } from '../cn_utilities';
import { cn_building } from '../../model/cn_building';
import { extension_instance } from '../../extension/cn_extension';
import { cn_zone } from '../../model/cn_zone';
import { cn_storey } from '../../model/cn_storey';
import { cn_plugin_option } from '../cn_plugin_option';

//***********************************************************************************
/**
 * Buils wall nomenclatures for the building
 * @param {cn_building} building
 * @returns {cn_nomenclature[]}
 */

export function cn_nomenclature_balconies(building) {
    const output = [];
    output.push(new cn_nomenclature('ID').withVirtual(true));
    output.push(new cn_nomenclature('Nom'));
    output.push(new cn_nomenclature('Type'));
    output.push(new cn_nomenclature('Niveau'));
    output.push(new cn_nomenclature('Index niveau').withVisibility(false));
    push_cn_nomenclatures_zones(output, true);
    output.push(new cn_nomenclature('Espace 1'));
    output.push(new cn_nomenclature('Espace 2'));
    output.push(new cn_nomenclature('Orientation').withNumberDefinition('°', 0));
    output.push(new cn_nomenclature('Longueur 1').withNumberDefinition('m', 3));
    output.push(new cn_nomenclature('Longueur 2').withNumberDefinition('m', 3));
    output.push(new cn_nomenclature('Hauteur').withNumberDefinition('m', 3));
    output.push(new cn_nomenclature('Epaisseur').withNumberDefinition('m', 3));
    output.push(new cn_nomenclature('Surface 1').withNumberDefinition('m²', 3));
    output.push(new cn_nomenclature('Surface 2').withNumberDefinition('m²', 3));
    output.push(new cn_nomenclature('Calques').withVisibility(false));
    if (cn_plugin_option.zpsos) {
        output.push(new cn_nomenclature('ZPSOs').withVisibility(false));
    }

    const zones = building.zones;
    building.storeys.length && building.storeys.forEach((storey) => {
        populate_nomenclature_balconies(storey, output, zones);
    });

    return output;
}

//***********************************************************************************
//***********************************************************************************
/**
 /**
 * Builds wall nomenclatures for the given storey
 * @param {cn_storey} storey
 * @param {any[]} output
 * @param {{[property: string]: cn_zone[]}} zones
 */
function populate_nomenclature_balconies(storey, output, zones) {
    const roof_volume = storey.build_space_volume();
    storey.scene.walls.filter(wall => wall.balcony).forEach(wall => wall.wall_interfaces.forEach((wi, wi_index) => {
        const balcony_type = wall.wall_type;
        let k = 0;

        //*** ID */
        output[k].values.push(wi.create_id_for_bbp(storey));
        k++

        //*** name */
        output[k].values.push(balcony_type.get_label());
        k++

        //*** Type */
        output[k].values.push(balcony_type.get_category_label());
        k++

        //*** storey */
        output[k].values.push(storey.get_storey_name());
        k++
        output[k].values.push(storey.get_storey_index_in_building());
        k++

        const s0 = (wall.get_flow_direction()) ? 0 : 1;
        const s1 = 1 - s0;

        //*** Zone */
        extension_instance.zone.get_zones_tools().forEach(tool_zone => {
            let zone_to_display = find_zone(zones[tool_zone.property], wi.spaces[s0].ID, storey.ID);
            if (!zone_to_display) {
                zone_to_display = find_zone(zones[tool_zone.property], wi.spaces[s1].ID, storey.ID);
            }
            output[k].values.push(zone_to_display);
            k++;
        });

        //*** Space 1 */
        output[k].values.push(wi.spaces[s0].get_name(storey));
        k++

        //*** Space 2 */
        output[k].values.push(wi.spaces[s1].get_name(storey));
        k++

        //*** orientation */
        var flow_normal = cn_mul(wall.bounds.normal, (s0 == 0) ? 1 : -1);
        output[k].values.push(cn_azimut(flow_normal, storey.building.compass_orientation));
        k++

        const wall_metrics = wi.get_metrics(storey);

        //*** length  */
        output[k].values.push(wall_metrics.side_length_1);
        k++
        output[k].values.push(wall_metrics.side_length_2);
        k++

        //*** height  */
        output[k].values.push(wall_metrics.height);
        k++

        //*** thickness  */
        output[k].values.push(wall_metrics.thickness);
        k++

        //*** full area  */
        output[k].values.push(wall_metrics.gross_side_area_1);
        k++
        output[k].values.push(wall_metrics.gross_side_area_2);
        k++

        //*** layers & zpsos  */
        k = export_layers_and_zpsos(storey, wall, balcony_type, output, k);
    }));
}
